import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en';
import ru from './locales/ru';
import uk from './locales/uk';

// the translations
const resources = {
  en,
  ru,
  uk
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: localStorage.getItem('language') || 'en', // default language
    fallbackLng: 'en', // fallback language
    
    keySeparator: '.', // we use keys in form messages.welcome
    nsSeparator: false, // disable namespace separator
    
    debug: true, // disable debug mode in production

    interpolation: {
      escapeValue: false // react already does escaping
    },

    // Save language preference to localStorage
    saveMissing: false,
  });

export default i18n;
